(function () {
    'use strict';

    angular.module('map')
        .directive('arcgisMap', function ($parse, ArcGISMap, $timeout) {
            return {
                //works on attribute
                restrict: 'A',
                link: function (scope, element) {
                    dojo.require('esri.map');
                    dojo.require('esri.tasks.GeometryService');
                    dojo.require('esri.tasks.ProjectParameters');
                    dojo.require('esri.symbols.SimpleLineSymbol');
                    dojo.require('esri/toolbars/draw');
                    dojo.require('esri/toolbars/edit');
                    dojo.require('dijit/Menu');
                    dojo.require('dijit/MenuItem');
                    dojo.require('dijit/MenuSeparator');
                    dojo.require('esri/geometry/Point');
                    dojo.require('esri/geometry/ScreenPoint');
                    dojo.require('esri.symbols.SimpleMarkerSymbol');

                    function init() {
                        $timeout(function () {
                            var map = ArcGISMap.set(element);
                            var par = element.parent();
                            element.remove();
                            par.append(map.container);
                        });
                    }

                    dojo.ready(init);
                }
            };
        });
})();
